import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { EvsErr } from "../evsErr";
import { EvsStampService } from "../../../../common/services/EvsStamp.service";

import { IOption } from "ng-select";
import { BatchstampService } from "../../qrcode/batchstamp/batchstamp.service";

declare var $: any;

@Component({
  selector: "evs-cancel-stamp",
  templateUrl: "cancel_stamp.template.html",
  // styleUrls: ['style.css'] ,
  styles: [
    `
      /deep/ #cancel-stamp-page ng-select {
        z-index: 5;
      }
      /deep/ #cancel-stamp-page ng-select > div {
        height: 100% !important;
      }
    `,
  ],
  providers: [EvsStampService, BatchstampService],
})
export class CancelStampComponent implements OnInit {
  title: string = "Hủy/Khóa tem";
  public message: any = {
    class: "alert-success",
    content: "",
    content_popup: "",
  };
  public activateStampForm: FormGroup;

  public list_product: Array<IOption> = [];
  // public list_order:any = [];
  public list_order: Array<IOption> = [];
  public list_order_full_param: any;
  public action: string = "active";
  btn_disable = false;

  public type_active: any = "order_id";

  public model: any = {};
  order_selected: any = {};

  public start_value: any;
  public end_value: any;
  start_value_suggest: any;
  end_value_suggest: any;
  public list_value: any;
  order_name = "";
  total_stamp = 0;
  total_stamp_in_batch = 0;
  total_active = 0;

  constructor(
    private stampService: EvsStampService,
    private _fb: FormBuilder,
    private batchService: BatchstampService
  ) {}

  ngOnInit() {
    // $('#select-order-id').select2({placeholder: '-- Chọn lô tem --', allowClear: true});

    //get list order
    this.getListOrder();

    this.createForm();
  }

  getListOrder() {
    this.stampService
      .listOrder({ status: 3, is_deleted: 0, limit: 500, desc: "id" })
      .toPromise()
      .then((res: any) => {
        // console.log('order',res);
        if (res.error == false) {
          this.list_order_full_param = res.data.orders;
          let listO = [];
          let i = 0;
          for (let item of res.data.orders) {
            let obj = {
              value: item.id,
              label: item.name,
              i: i,
            };
            listO.push(obj);
            i++;
          }
          this.list_order = listO;
        } else {
          EvsErr.evs_err(res, false);
        }
      })
      .catch((err: any) => {
        EvsErr.evs_err(err);
      });
  }

  createForm() {
    this.activateStampForm = this._fb.group({
      status: ["deactive", [Validators.required]],
      order_id: [null],
      start: [null],
      end: [null],
      list: [null],
      select_type_active: [this.type_active],
    });
  }
  onSubmit(data: any) {
    console.log(data);
    this.btn_disable = true;
    let request: any = {};
    this.order_name = "";
    if (data.select_type_active == "order_id") {
      this.order_name = this.order_selected.name;
      request.start = this.order_selected.id_start;
      request.end = this.order_selected.id_end;
      this.total_stamp = this.order_selected.quantity;
    } else if (data.select_type_active == "batch") {
      request.start = this.serialToNumber(data.start);
      request.end = this.serialToNumber(data.end);
      this.total_stamp = request.end - request.start + 1;
    } else if (data.select_type_active == "list") {
      // list
      let arr_list = data.list.split(",");
      this.total_stamp = arr_list.length;
      let list = [];
      for (let item of arr_list) {
        list.push(this.serialToNumber(item));
      }
      request.list = list;
    } else {
      // warning
    }

    // console.log('data',data);
    // console.log('request',request);
    let title_mess = data.status == "deactive" ? "Hủy kích hoạt " : "Khóa ";
    $("#stamp-active-message").hide(100);
    this.stampService
      .changeStampStatus(request, data.status)
      .toPromise()
      .then((res: any) => {
        this.btn_disable = false;
        if (res.error == false) {
          this.total_active = res.data.nModified;
          $("#activeSuccessAlert").modal();
          this.message.class = "success";
          this.message.content_popup =
            "Yêu cầu " +
            title_mess +
            " tem thành công. <br> Hệ thống sẽ tự động " +
            title_mess +
            " các tem được yêu cầu trong thời gian sớm nhất";
          $("#stamp-active-message").show(200);
        } else {
          // this.message.class='warning';
          // this.message.content=title_mess+'chưa thành công. Vui lòng thử lại';
          // $('#stamp-active-message').show(200);
          //
          // EvsErr.evs_err(res,false);
          // let body = $("html, body");
          // body.stop().animate({scrollTop:0}, 500, 'swing', function() {});

          this.message.class = "warning";
          this.message.content_popup =
            "Yêu cầu" +
            title_mess +
            " tem KHÔNG thành công. <br> Vui lòng thử lại sau!";
          $("#stamp-active-message").show(200);
        }
      })
      .catch((err: any) => {
        this.btn_disable = false;
        this.message.class = "warning";
        this.message.content = title_mess + "chưa thành công. Vui lòng thử lại";
        EvsErr.evs_err(err, false);
        let body = $("html, body");
        body.stop().animate({ scrollTop: 0 }, 500, "swing", function () {});
      });
  }

  select_order(event) {
    this.order_selected = this.list_order_full_param[event.i];
    // console.log(this.order_selected);
    // console.log(event);
    // console.log(this.list_order_full_param[event.i]);
    // let order_id = event.value;
    // // batchService
    // this.batchService.getDetailsOrder(order_id).subscribe(res => {
    //     if (res.status == 200) {
    //         this.order_name = res.data.name;
    //         this.start_value = this.start_value_suggest = this.formatSerial(res.data.id_start, res.data.prefix);
    //         this.end_value = this.end_value_suggest = this.formatSerial(res.data.id_end, res.data.prefix);
    //         this.total_stamp_in_batch = res.data.quantity;
    //     } else if (res.status == 400) {
    //         this.message.class = 'warning';
    //         this.message.content = res.status;
    //         let body = $('html, body');
    //         body.stop().animate({scrollTop: 0}, 500, 'swing', function () {
    //         });
    //     }
    // });
  }

  formatSerial(serial, prefix: string = "") {
    let format_serial: string;
    let prefix2 = prefix ? prefix + "-" : "";
    serial = serial.toString();
    if (serial.length > 6) {
      format_serial = prefix2 + serial;
    } else {
      let pad = "000000";
      format_serial = prefix2 + pad.substring(0, 6 - serial.length) + serial;
    }

    return format_serial;
  }
  serialToNumber(serial) {
    let _serial = serial.split("-");
    if (_serial.length == 1) {
      return parseInt(_serial[0]);
    } else {
      return parseInt(_serial[_serial.length - 1]);
    }
  }

  empty(data) {
    if (typeof data == "number" || typeof data == "boolean") {
      return false;
    }
    if (typeof data == "undefined" || data === null) {
      return true;
    }
    if (typeof data.length != "undefined") {
      return data.length == 0;
    }
    let count = 0;
    for (let i in data) {
      if (data.hasOwnProperty(i)) {
        count++;
      }
    }
    return count == 0;
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/stamp/cancel-stamp.component.ts